import React, { Component } from 'react';
import PositionPanel from '../market/PositionPanel';
import { Row, Col } from 'reactstrap';
import { firestoreConnect } from 'react-redux-firebase';
import { connect } from 'react-redux';
import { compose } from 'redux';

class SideBar extends Component {
    render() {
        let portfolioValue = 0;

        if(this.props.tradebook && this.props.companies) {
            const tradebook = this.props.tradebook[0];
            const prices = {}

            for(const c in this.props.companies) {
                const company = this.props.companies[c];
                prices[company.id] = parseFloat(company.price)
            }

            for(const key in tradebook) {
                const trade = tradebook[key];

                if(trade.type === 'buy') {
                    portfolioValue += (prices[trade.company] * parseInt(trade.amount))
                }
            }
        }

        return (
            <Col className="orderMaster" md="3" lg="3">
                <Row className="panel">
                    <PositionPanel portfolioValue={portfolioValue} />
                </Row>
            </Col>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        tradebook: state.firestore.ordered.tradebook,
        companies: state.firestore.ordered.companies
    };
};

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => [
        {
            collection: 'trading-book',
            doc: props.auth.uid,
            storeAs: 'tradebook',
        },
        { collection: 'companies' },
    ]),
)(SideBar);